import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import AudienceSegmentationContextProviderQuery, {
	type AudienceSegmentationContextProviderQuery$data,
	type AudienceSegmentationContextProviderQuery$variables,
} from './__generated__/AudienceSegmentationContextProviderQuery.graphql';

export function preloadAudienceSegmentationContext({ accountId }: { accountId: string }) {
	return query<
		AudienceSegmentationContextProviderQuery$data,
		AudienceSegmentationContextProviderQuery$variables
	>({
		query: AudienceSegmentationContextProviderQuery,
		variables: {
			accountId,
		},
	});
}
